import { useState } from "react"
import { useNavigate } from "react-router-dom"
import axios from "axios"
import * as yup from "yup"
import schema from "../validation/formSchema"

import Banner from "../navigation/Banner"
import NavBar from "../navigation/NavBar"
import ForgotEmail from "../forms/ForgotEmail"
import ForgotSecurity from "../forms/ForgotSecurity"
import ResetPassword from "../forms/ResetPassword"

import { toast } from "react-toastify"
import 'react-toastify/dist/ReactToastify.css';
toast.configure()

// Email
const initialEmailForm = {
  email: ""
}

// Security Question
const initialSecurityForm = {
  email: "",
  sec_question: "",
  sec_answer: ""
}

// Password Reset
const initialResetForm = {
  email: "",
  password: ""
}

// Form Errors
const initialFormErrors = {
  email: "",
  display_name: "",
  password: "",
  sec_question: "",
  sec_answer: ""
}

function Forgot({ setUser }) {
  const [ emailForm, setEmailForm ] = useState(initialEmailForm)
  const [ securityForm, setSecurityForm ] = useState(initialSecurityForm)
  const [ resetForm, setResetForm ] = useState(initialResetForm)
  const [ formErrors, setFormErrors ] = useState(initialFormErrors)  
  const navigate = useNavigate()

  const handleEmailChange = e => {
    const {name, value} = e.target

    yup
      .reach(schema, name)
      .validate(value)
      .then(() => {
        setFormErrors({
          ...formErrors,
          [name]: ""
        })
      }).catch(err => {
        setFormErrors({
          ...formErrors,
          [name]: err.errors[0]
        })
      })

      setEmailForm({
        ...emailForm,
        [e.target.name]: e.target.value
      })
  }

  const handleSecurityChange = e => {
    const {name, value} = e.target

    yup
      .reach(schema, name)
      .validate(value)
      .then(() => {
        setFormErrors({
          ...formErrors,
          [name]: ""
        })
      }).catch(err => {
        setFormErrors({
          ...formErrors,
          [name]: err.errors[0]
        })
      })

      setSecurityForm({
        ...securityForm,
        [e.target.name]: e.target.value
      })
  }

  const handleResetChange = e => {
    const {name, value} = e.target

    yup
      .reach(schema, name)
      .validate(value)
      .then(() => {
        setFormErrors({
          ...formErrors,
          [name]: ""
        })
      }).catch(err => {
        setFormErrors({
          ...formErrors,
          [name]: err.errors[0]
        })
      })

      setResetForm({
        ...resetForm,
        [e.target.name]: e.target.value
      })
  }

  const handleEmailSubmit = e => {
    e.preventDefault()
    emailForm.email = emailForm.email.toLowerCase()
    
    axios.get(`https://roma-be.herokuapp.com/api/auth/forgot/email/${emailForm.email}`)
      .then(res => {
        setSecurityForm({...securityForm,
          email: res.data.email,
          sec_question: res.data.sec_question
        })
      })
  }

  const handleSecuritySubmit = e => {
    e.preventDefault()
    securityForm.email = securityForm.email.toLowerCase()
    
    axios.post(`https://roma-be.herokuapp.com/api/auth/forgot/security/${securityForm.email}/${securityForm.sec_answer}`)
      .then(res => {
        setResetForm({...resetForm,
          email: res.data.user.email,
          sec_question: res.data.user.sec_question,
          sec_answer: securityForm.sec_answer
        })
      })
  }

  const handleResetSubmit = e => {
    e.preventDefault()
    resetForm.email = resetForm.email.toLowerCase()
    
    axios.put(`https://roma-be.herokuapp.com/api/auth/reset`, resetForm)
      .then(res => {
        toast("Password reset successful!")
        navigate("/register")
      })
  }

  return (
    <div className="register-page-container" >
      <Banner />
      <NavBar />

      <div className="register-page-content-container">
        <div className="register-content-1">
          <div className="log-in-container">
            <h1 className="register-h1">Password Reset</h1>

            {!resetForm.email ?
              !securityForm.sec_question ?
                <ForgotEmail 
                  handleEmailChange={handleEmailChange} 
                  handleEmailSubmit={handleEmailSubmit} 
                  emailForm={emailForm} 
                  formErrors={formErrors}
                /> : 
                <ForgotSecurity 
                  handleSecurityChange={handleSecurityChange} 
                  handleSecuritySubmit={handleSecuritySubmit} 
                  securityForm={securityForm} 
                  formErrors={formErrors}
                />
              :
              <ResetPassword 
                handleResetChange={handleResetChange}
                handleResetSubmit={handleResetSubmit} 
                resetForm={resetForm} 
                formErrors={formErrors}
              />
            }
          </div>
        </div>
      </div>
    </div>
  )
}

export default Forgot
